import { render } from "./AyudaOdontologia.vue?vue&type=template&id=d01fa6da&scoped=true"
import script from "./AyudaOdontologia.vue?vue&type=script&lang=js"
export * from "./AyudaOdontologia.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=d01fa6da&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d01fa6da"]])

export default __exports__